import {
  TOPBAR_SWITCH_LOGOUT_DIALOG_VISIBILITY
  } from "../lib/types";

  const initialState = {
    showLogoutDialog: false,
  };

  export default (state = initialState, action) => {
    /* discriminate the action type */
    switch (action.type) {
      case TOPBAR_SWITCH_LOGOUT_DIALOG_VISIBILITY:
      return {
        ...state,
        showLogoutDialog: action.payload
      };
      default:
        return state;
    }
  };



// WEBPACK FOOTER //
// ./src/reducers/top-bar-reducer.js